module.exports = {"school-name":"College of Eastern Idaho","logo":"/sites/cew/header_logo.png","logout-color":"#0060a9","logout-font-color":"#fff","header-color":"#fff","header-font-color":"#000","header-border-color":"#0060a9","footer-color":"#0060a9","footer-info":"© 2022 College of Eastern Idaho | The Write Class™ | © 2022 Boise State University","help-button-color":"#fdb827","help-button-font-color":"#000000"}


//////////////////
// WEBPACK FOOTER
// ./sites/cei/site-config.json
// module id = 116
// module chunks = 12